import { Box, useTheme } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

import { cardClassIdentifier, cardStyles } from './sharedCardStyles';

/**
 * Renders an empty Card without padding
 */
const CardMain: FC<PropsWithChildren> = ({ children }) => {
  const theme = useTheme();

  return (
    <Box className={cardClassIdentifier} sx={cardStyles(theme)}>
      {children}
    </Box>
  );
};

export default CardMain;
